<template>
	<div class="con">
		<div class="head">
			<div class="total-num">
				<div class="totla-s">35746<span>个</span></div>
			</div>
			<div class="head-disp">
				<div class="head-d">
					<div class="head-d-num">34456</div>
					<div>门诊</div>
				</div>
				<div class="head-d">
					<div class="head-d-num">3456</div>
					<div>住院</div>
				</div>
			</div>
		</div>
		<div class="time">
			<div class="time-year">
				<van-cell is-link @click="showPopup">{{columns[columnsIndex]}}</van-cell>
				<van-popup :close-on-click-overlay=false position="bottom" :style="{ height: '30%' }" v-model="columnsShow">
					<div class="time-choose">
						<div @click="cancel">取消</div>
						<div class="choose" @click="GetChooseIndex">确定</div>
					</div>
					<van-picker :columns="columns" @change="onChangeReg" />
				</van-popup>
			</div>
			<div class="time-nav">
				<div class="time-nav-num" v-for="(item,index) in Month" @click="getMothList(index)" :class="[index == MonthIndex ? 'MonthCative':'']">{{item.text}}</div>
			</div>
		</div>
		<div class="list">
			<div id="chart_line" ref="chart_line"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'staReg',
		data() {
			return {
				columns: [],//年列表
				columnsIndex: 0,//选择年下标
				cIndex: 0,//确定后的下标
				columnsShow: false,
				Month:[],
				MonthIndex: 0,
				List: [],
			}
		},
		methods: {
			//挂号报表
			GetGhmxReport(){
				this.$store.commit('Load',true)
				let MonthNum = this.Month[this.MonthIndex].text;
				if(MonthNum == '全年'){
					MonthNum = '';
				}else{
					MonthNum = MonthNum.split('月')[0];
					
					if(MonthNum < 10){
						MonthNum = '0' + MonthNum;
					}
					console.log(MonthNum)
				}
				let that = this;
				this.$Axios.Get('/getGhmxReport?year='+ this.columns[this.columnsIndex] +'&month='+ MonthNum, null).then(res => {
					console.log(res)
					this.$store.commit('Load',false)
					if(res.code == 0){
						this.List = res.msg;
						if(res.msg.INPAT != 0){
							setTimeout(()=>{
								that.totalLine();	
							},300)
						}
						
					}
				}).catch(err => {
					this.$store.commit('Load',false)
					this.List = '';
					console.log(err)
				})
			},
			//折线图
			totalLine() {
				let myChartLine = this.$echarts.init(this.$refs.chart_line);
				if(myChartLine){
					
					let dataList = this.List;
					console.log(dataList)
					
					
					let option = {
					title: {
						text: '住院VS门诊'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						data: ['门诊', '住院']
					},
					grid: {
						left: '3%',
						right: '2%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisLine: { //y轴
							show: false
						},

					data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15','16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
					}],
					yAxis: [{
						type: 'value',
						axisLine: { //y轴
							show: false
						},

					}],
					series: [

						{
							name: '门诊',
							type: 'line',
							 smooth: true,
							stack: '总量',
							areaStyle: {},
							symbolSize: 8, //设定实心点的大小
							data: [320, 332, 301, 334, 390, 330, 320,320, 232, 301, 334, 390, 330, 320, 132, 301, 334, 390, 330, 320,320, 332, 301, 334, 390, 330, 320, 240,312,200],
							itemStyle: {
								normal: {
									color: '#27BEC4', //改变折线点的颜色
									lineStyle: {
										color: '#fff' //改变折线颜色
									}
								}
							},
						},
						{
							name: '住院',
							type: 'line',
							 smooth: true,
							stack: '总量',
							label: {
								normal: {
									show: true,
									position: 'top'
								}
							},
							areaStyle: {},
							symbolSize: 8, //设定实心点的大小
							data: [140, 302, 190, 293, 259, 130, 120,140, 302, 190, 293, 149, 130, 120,140, 302, 190, 293, 129, 130, 120,140, 302, 190, 293, 329, 130, 120,200,146],
							itemStyle: {
								normal: {
									color: '#00AFFE', //改变折线点的颜色
									lineStyle: {
										color: '#fff' //改变折线颜色
									}
								}
							},
						}
					]
				};
				myChartLine.setOption(option);
				}
				
			},
			//获取月
			getMothList(e){
				this.MonthIndex = e;
				this.GetGhmxReport();
				let MonthNum = this.Month[e].text;
				let listNum = [];
				if(MonthNum == '全年'){
					for(let i = 1,len = this.Month.length;i < len;i++){
						listNum.push(i)
					}
					console.log(listNum)
				}else{
					MonthNum = MonthNum.split('月')[0];
					 //构造一个日期对象：
					  let day = new Date( this.columns[this.columnsIndex], MonthNum, 0); 
					  console.log(day)
					  //获取天数：
					  let daycount = day.getDate(); 
					  console.log(daycount)
				}
			},
			//显示底部弹出框
			showPopup() {
		      this.columnsShow = true;
		      this.cIndex = this.columnsIndex;
		    },
		    //选择年份获取下标
			onChangeReg(picker, value, index) {
				console.log(index)
		      	this.columnsIndex = index;
		      	this.newMonth();
		    },
		    //确定
		    GetChooseIndex(){
		    	this.columnsShow = false;
		    	this.newMonth();
		    	this.MonthIndex = 0;
		    	this.GetGhmxReport();
		    },
		    //取消选择
		    cancel(){
		    	this.columnsShow = false;
		    	this.columnsIndex = this.cIndex;
		    	this.newMonth();
		    },
		    //年
			newTime(){
				let newYear = new Date().getFullYear();
				let yearList = [];
				for(let i = 0; i < 3; i++) {
					yearList.push(newYear - i)
				}
				this.columns = yearList;
			},
			//月
			newMonth(){
				let newYear = new Date().getFullYear();
				let monthList = [];
				if(newYear == this.columns[this.columnsIndex]){//当前年
					let newMonth = new Date().getMonth() + 1;
					monthList.push({text:'全年'})
					for(let i = newMonth;i > 0;i--){
						monthList.push({
							text: i +'月'
						})
					}
					this.Month = monthList;
				}else{
					monthList.push({text:'全年'})
					for(let i = 12;i > 0;i--){
						monthList.push({
							text: i +'月'
						})
					}
					this.Month = monthList;
				}
			},
		},

		mounted() {
			this.newTime();
			this.newMonth();
			this.GetGhmxReport();
		},
		created() {

		},
	}
</script>

<style scoped>
	.con{
		width: 100%;
		height: 100%;
	}
	.head {
		padding-top: 20px;
		width: 100%;
		height: 40vh;
		background: #27BEC4;
	}
	.head-disp{
		margin-top: 10px;
		display: flex;
		justify-content: space-around;
	}
	.head-d{
		color: #fff;
		font-size: 15px;
		text-align: center;
	}
	.head-d-num{
		margin-bottom: 5px;
		font-size: 18px;
		font-weight: 700;
	}
	.time{
		display: flex;
		align-items: center;
		padding: 0 0 10px 0;
		background-color: #fff;
		font-size: 15px;
	}
	.van-cell{
		padding: 10px 10px;
		background: linear-gradient(#ccc,#27BEC4);
		color: #fff;
		font-size: 18px;
	}
	.time-choose{
		padding: 10px 20px;
		display: flex;
		justify-content: space-between;
	}
	.choose{
		color: #0570DB;
	}
	.van-popup{
		overflow: hidden;
	}
	.time-nav{
		display: flex;
	 	display: inline;
		  white-space: nowrap;
		  overflow-x: scroll;
		  overflow-y: hidden
	}
	.time-nav-num{
		padding: 12px 30px;
		background-color: #27BEC4;
		color: #fff;
		 display:inline-block;
	}
	.MonthCative{
		background: #fff;
		color: #000;
		font-weight: 700;
	}
	.total-num {
		margin: 0 auto;
		width: 180px;
		height: 180px;
		border: 2px solid #fff;
		border-radius: 50%;
		text-align: center;
		line-height: 180px;
	}
	
	.totla-s {
		font-size: 24px;
		font-weight: 700;
		color: #fff;
	}
	
	.totla-s span {
		font-size: 15px;
		font-weight: 400;
	}
	.list{
		height: 40vh;
		background: #fff;
	}
	#chart_line {
		margin-top: 10px;
		width: 100%;
		height: 300px;
		background: #FFF;
	}
</style>